import { render, staticRenderFns } from "./StudentPeiControversy.vue?vue&type=template&id=3715af33&scoped=true&"
import script from "./StudentPeiControversy.vue?vue&type=script&lang=js&"
export * from "./StudentPeiControversy.vue?vue&type=script&lang=js&"
import style0 from "./StudentPeiControversy.vue?vue&type=style&index=0&id=3715af33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715af33",
  null
  
)

export default component.exports